import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { AtsCandidatesDataTableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import { AddCandidatesToJobPostingModal } from 'modules/ats/components/candidates/AddCandidateToJobPostingModal'

enum Action {
  AddToJobPosting,
}

export const TableBulkActions = () => {
  const [action, setAction] = React.useState<Action | null>(null)
  const dataTable = useDataTable<AtsCandidatesDataTableQuery>()
  const selectedCandidates = [...dataTable.selectedRows].map((v) => Number(v))

  return (
    <>
      {selectedCandidates.length > 0 && (
        <Box flexDirection="row" gap="s8">
          <Button type="secondary" onClick={() => setAction(Action.AddToJobPosting)}>
            {i18n.t('ats.candidates.add_to_job_opening_button')}
          </Button>
        </Box>
      )}

      {action === Action.AddToJobPosting && (
        <AddCandidatesToJobPostingModal
          candidateIds={selectedCandidates}
          onSuccess={() => setAction(null)}
          onClose={() => setAction(null)}
        />
      )}
    </>
  )
}
